import React from 'react';

function Loading() {
    return (
        <div style={{marginTop: '10px'}}>
            Loading...
        </div>
    );
}

export default Loading;